import React from "react";
import { FaIcon } from "./Fa.Icon";

export function DraftIcon() {
  return <FaIcon name={"eye-slash"} type={"s"} />;
}
